import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { Contents } from './components/Contents';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-800" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <Contents data-id="element-5" />
      <Comparison data-id="element-6" />
      <Pricing data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalOffer data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchaseNotification data-id="element-11" />
    </div>;
}